/* eslint-disable react/destructuring-assignment */
import React from 'react';
import tw, { css } from 'twin.macro';
// import Img from 'gatsby-image';
import CTAButton from './CTAButton';
import { stringifyArray } from '../utils';

const Container = tw.div`flex flex-col items-end sm:w-1/3`;
const Facts = tw.div`flex flex-wrap relative border border-solid border-blue-dark bg-white text-blue-dark`;
const Label = tw.span``;
const P = tw.p`font-semibold mb-0`;

const factBoxStyles = css`
  ${tw`flex flex-wrap w-full sm:(w-3/4)`}

  div {
    ${tw`w-1/2 xl:w-1/4`}
  }

  div:nth-of-type(5),
  div:nth-of-type(6),
  div:nth-of-type(7),
  div:nth-of-type(8) {
    padding-top: 0;
  }
`;

const Fact = ({ children, label, fact, ...rest }) => (
  <div tw="w-full px-8 py-6 xl:w-1/2" {...rest}>
    <Label>{label}</Label>
    <P>{fact}</P>
    {children}
  </div>
);

const LastUpdated = ({ date }) => (
  <div tw="absolute -top-6 right-0 text-blue text-xs opacity-50 italic">Updated {date}</div>
);

export const TalentFacts = ({
  name,
  jobPosition,
  yearStartedInTech,
  company,
  homeCountry,
  meta: { updatedAt },
}) => (
  <Container>
    <Facts>
      {name && (
        <Fact label="Name" fact={name} tw="border-b border-solid border-blue-dark xl:w-full" />
      )}
      <Fact label="Country of Origin" fact={homeCountry?.country || 'Unknown'} />
      {jobPosition && (
        <Fact label="Position" fact={jobPosition} tw="pt-0 xl:(pl-0 pt-6)">
          {company[0] && (
            <a
              href={company[0].website}
              target="_blank"
              rel="noopener noreferrer"
              tw="block font-semibold text-lg"
            >
              @{company[0].name}
            </a>
          )}
        </Fact>
      )}
      <Fact
        label="Years in Tech"
        fact={yearStartedInTech ? new Date().getFullYear() - yearStartedInTech : 'Unknown'}
        tw="pt-0"
      />
      <LastUpdated date={updatedAt} />
    </Facts>
    {company[0] && (
      <CTAButton label="Company Website" href={company[0].website} external blueOutline />
    )}
    {company[0]?.jobOpenings && (
      <CTAButton label="Jobs @ Company" href={company[0].jobOpenings} external blueOutline />
    )}
  </Container>
);

export const CompanyFacts = ({
  name,
  yearFounded,
  ecospheres,
  markets,
  founders,
  numberOfEmployees,
  fundingUsd,
  fundingDkk,
  website,
  jobOpenings,
  meta: { updatedAt },
  logo,
}) => (
  <Container tw="sm:w-full">
    <Facts tw="flex-col sm:(w-full flex flex-row)">
      {logo && (
        <div tw="text-center border-b border-solid border-blue-dark w-full pt-4 pb-3 px-3 flex justify-center items-center xl:(w-1/4 border-r border-b-0)">
          <img src={logo.url} />
          {/* {logo.format === 'svg' ? (
          ) : (
            // <Img fixed={logo.fixed} imgStyle={{ opacity: 1, background: 'white' }} />
          )} */}
        </div>
      )}
      <div css={factBoxStyles}>
        <Fact label="Name" fact={name} />
        {founders?.length > 0 && <Fact label="Founder(s)" fact={stringifyArray(founders)} />}
        {ecospheres?.lenth > 0 && <Fact label="Industry" fact={stringifyArray(ecospheres)} />}
        {numberOfEmployees && <Fact label="Number of employees" fact={numberOfEmployees} />}
        {yearFounded && <Fact label="Founded" fact={yearFounded} />}
        {markets.length > 0 && <Fact label="Market(s)" fact={stringifyArray(markets)} />}
        {(fundingUsd || fundingDkk) && (
          <Fact
            label="Funding"
            fact={
              fundingUsd && fundingDkk
                ? `${fundingUsd}M USD // ${fundingDkk}M DKK`
                : (fundingUsd && `${fundingUsd}M USD`) || (fundingDkk && `${fundingDkk}M DKK`)
            }
          />
        )}
      </div>
      <LastUpdated date={updatedAt} />
    </Facts>
    <div tw="w-full sm:(w-1/2)">
      <CTAButton label="Website" href={website} external blueOutline />
      <CTAButton label="Job Openings" href={jobOpenings} external blueOutline />
    </div>
  </Container>
);
